import { render, staticRenderFns } from "./userAuthorizationRoleDropDown.vue?vue&type=template&id=b6435a18&scoped=true"
import script from "./userAuthorizationRoleDropDown.vue?vue&type=script&lang=js"
export * from "./userAuthorizationRoleDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6435a18",
  null
  
)

export default component.exports